import { render, staticRenderFns } from "./EllipsisTooltip.vue.vue?vue&type=template&id=728c5e7a&scoped=true"
import script from "./EllipsisTooltip.vue.vue?vue&type=script&lang=js"
export * from "./EllipsisTooltip.vue.vue?vue&type=script&lang=js"
import style0 from "./EllipsisTooltip.vue.vue?vue&type=style&index=0&id=728c5e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c5e7a",
  null
  
)

export default component.exports